import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  onClick: () => void;
}
const SvgSearchBtn: React.FC<Props> = ({ onClick }) => {
  const isRtl = useIsRtl();
  return (
    <svg
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={{
        color: "var(--primary-color)",
        ...(isRtl
          ? { WebkitTransform: "scaleX(-1)", transform: "scaleX(-1)" }
          : {}),
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" className="fill-gray5" />
      <path
        d="M10.6875 5.25C7.69111 5.25 5.25 7.69112 5.25 10.6875C5.25 13.6839 7.69111 16.125 10.6875 16.125C11.9836 16.125 13.1751 15.6671 14.1108 14.9062L17.7898 18.5852C17.8416 18.6392 17.9037 18.6823 17.9724 18.712C18.0411 18.7417 18.115 18.7574 18.1899 18.7581C18.2647 18.7589 18.3389 18.7447 18.4082 18.7164C18.4775 18.6881 18.5405 18.6463 18.5934 18.5934C18.6463 18.5405 18.6881 18.4775 18.7164 18.4082C18.7447 18.3389 18.7589 18.2647 18.7581 18.1899C18.7574 18.115 18.7417 18.0411 18.712 17.9724C18.6823 17.9037 18.6392 17.8416 18.5852 17.7898L14.9062 14.1108C15.6671 13.1751 16.125 11.9836 16.125 10.6875C16.125 7.69112 13.6839 5.25 10.6875 5.25ZM10.6875 6.375C13.0759 6.375 15 8.29911 15 10.6875C15 11.851 14.5411 12.9021 13.7966 13.6765C13.7507 13.7102 13.7102 13.7507 13.6765 13.7966C12.9021 14.5411 11.851 15 10.6875 15C8.29911 15 6.375 13.0759 6.375 10.6875C6.375 8.29911 8.29911 6.375 10.6875 6.375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgSearchBtn;
